{
  "instances": {
    "logfile": {
      "label": "Annálaskrá",
      "download": "Niðurhal",
      "wrap_lines": "Línuskipting",
      "page_up": "Síða upp",
      "page_down": "Síða niður",
      "previous_chunk": "Fyrri hluti",
      "next_chunk": "Næsti hluti",
      "resume_follow": "Fylgja aftur",
      "stop_follow": "Hætta að fylgja",
      "reconnecting": "Endurtengist...",
      "compressed_reset": "Atvikaskrá þjöppuð, síðan er endurstillt"
    }
  }
}
